export default __webpack_public_path__ + "static/media/sustainability.e2d1c5d9.png";